import { getLogger } from "@expert/logging";
import { Button, type ButtonProps, Text } from "@mantine/core";
import { withClickAnalytics } from "@soluto-private/eventualize-react";
import { useMutation } from "@tanstack/react-query";
import { useAgentSdk } from "@/sdk";
import type { ChatTask } from "@/sdk/agent/chat";

const AnalyticButton = withClickAnalytics(Button<"button">, "Click");
const logger = getLogger({ module: "CloseChatButton" });

export default function CloseChatButton({ chatTask, size = "sm" }: { chatTask: ChatTask } & ButtonProps) {
    const agentSdk = useAgentSdk();

    const { isPending, mutateAsync: endChatTaskWrapup } = useMutation({
        mutationFn: async () => {
            if (chatTask.status === "wrapping") {
                await agentSdk.endWrapup("AgentTerminatedWrapping", chatTask.partner, chatTask);
            } else {
                logger.error("Task is in an invalid state to close chat");
            }
        },
    });

    return (
        <AnalyticButton
            analytics={{ actionId: "CloseChatButton" }}
            id={`close-chat-button-chatId-${chatTask.chatId}`}
            aria-label="Close chat"
            data-testid="close-chat-button"
            disabled={isPending || chatTask.status !== "wrapping"}
            loading={isPending}
            size={size}
            color="asurion.5"
            onClick={() => void endChatTaskWrapup()}
        >
            <Text size="xs">Close chat</Text>
        </AnalyticButton>
    );
}
